module.exports = __webpack_public_path__ + "img/syukyaku-top-002.fb870e51.jpg";